export const ACCOUNT_IMPORT_STATE = Object.freeze({
    IDLE: 'idle',
    READY_TO_VALIDATE: 'ready-to-validate',
    VALIDATING: 'validating',
    VALID: 'valid',
    READY_TO_IMPORT: 'ready-to-import',
    IMPORTING: 'importing',
    IMPORTED: 'imported',
    INVALID: 'invalid',
    FAILED: 'failed',
});

export const ACCOUNT_IMPORT_RESULT_KIND = Object.freeze({
    VALID: 'valid',
    INVALID: 'invalid',
    FAILED: 'failed',
    IMPORTED: 'imported',
});

export const ACCOUNT_IMPORT_RESPONSE_STATUS = Object.freeze({
    VALID: 'valid',
    INVALID: 'invalid',
    IMPORTED: 'imported',
    FAILED: 'failed',
});

export const ACCOUNT_IMPORT_INVALID_REASON = Object.freeze({
    MISSING_ARCHIVE_UPLOAD: 'missing_archive_upload',
    INVALID_ZIP_ARCHIVE: 'invalid_zip_archive',
    ARCHIVE_UPLOAD_TOO_LARGE: 'archive_upload_too_large',
    ARCHIVE_ATTACHMENT_ENTRY_TOO_LARGE: 'archive_attachment_entry_too_large',
    ARCHIVE_ATTACHMENT_TOTAL_TOO_LARGE: 'archive_attachment_total_too_large',
    UNSAFE_ARCHIVE_ENTRY_PATH: 'unsafe_archive_entry_path',
    INVALID_GAME_ARCHIVE_PATH: 'invalid_game_archive_path',
});
